module.exports = __webpack_public_path__ + "static/media/main1.b358299f.jpg";